import Deprecated from '../../core/Deprecated';
import { withRouter } from 'react-router-dom';
import { APPLICATION_PATHS } from '../../application-core/constants';
import ComponentLink from '../../application-core/ComponentLink';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import SearchDropDown from '../../core/SearchDropDown';
import GS from '../../grafsync/grafsync';
import { Typography } from '@material-ui/core';
import GridOnIcon from '@material-ui/icons/GridOn';

class ProjectDataSearch extends Component {

  onFoundResource = (id, result) => {
    if (result.inDataset) {
      // Find the first loaded dataset
      const foundDataset = result.inDataset.find(dataset => GS.isLoaded(dataset, this.props.graph));
      if (foundDataset) {
        const link = APPLICATION_PATHS.DATA_MANAGER + '/project/dataset#project=' +
          this.props.project + "&dataset=" + foundDataset + "&resource=" + id;
        this.props.history.push(link);
      }
    }
  };

  render() {

    const { defaultLang, graph } = this.props;

    return (
      <div style={{ height: 40, maxWidth: 400, marginBottom: 12, overflow: 'visible' }}>
        <SearchDropDown
          dataTest="find-dataset"
          search={(value, lang) => {
            return {
              search: [
                {
                  predicate: "http://www.w3.org/1999/02/22-rdf-syntax-ns#type",
                  value: ["https://grafsync.graphifi.com/schema/gs/Resource"]
                },
                {
                  predicate: ["https://grafsync.graphifi.com/schema/gs/inDataset"]
                },
                {
                  predicate: ["http://www.w3.org/2000/01/rdf-schema#label"],
                  value: value,
                  isExactMatch: false
                }
              ],
              graph: [graph],
              language: lang,
              predicates: [
                "http://www.w3.org/2000/01/rdf-schema#label",
                "http://www.w3.org/2002/07/owl#deprecated",
                "http://www.w3.org/1999/02/22-rdf-syntax-ns#type",
                "https://grafsync.graphifi.com/schema/gs/inDataset"
              ]
            };
          }}
          sortProp="label"
          suppressMessages={true}
          listSecondIcon={(result) => {
            if (result.deprecated) return <Deprecated />;
            return null;
          }}
          listDisplay={(result, lang) => <div>
            <div data-test="result-label">
              <Typography variant="body2">
                <span style={{ wordBreak: 'break-word' }}>
                  {result.label[lang] ?
                    result.label[lang]
                    :
                    result.id
                  }
                </span>
              </Typography>
            </div>
            {result.inDataset &&
              <div>
                {result.inDataset.map((dataset, index) => {
                  if (index < 2 || (index < 3 && result.inScheme.length === 3)) {
                    return <ComponentLink
                      margin={true}
                      key={dataset}
                      id={dataset}
                      handleNotAvailable={true}
                      graph={graph}
                      defaultLang={defaultLang} />;
                  }
                  else return null;
                })}
                {result.inDataset.length > 3 &&
                  <Typography
                    data-test="too-many-datasets"
                    variant="caption"
                    style={{ marginLeft: 20, marginTop: 4 }}>Additional datasets were also found ({result.inDataset.length - 2}).</Typography>
                }
              </div>
            }
          </div>
          }
          listSelectionDisplay={(result, lang) => {
            if (result.label && result.label[lang]) {
              return result.label[lang];
            }
            else return result.id;
          }}
          title="Find a resource"
          lang={defaultLang}
          chosen={this.onFoundResource} />
      </div>
    );
  }

}

ProjectDataSearch.propTypes = {
  project: PropTypes.string.isRequired,
  history: PropTypes.object,
  graph: PropTypes.string.isRequired,
  defaultLang: PropTypes.string.isRequired
};

export default withRouter(ProjectDataSearch);